import { ServiceSelectionAction } from 'actions/SelectedServicesActions';

import {
  CLEAR_SERVICES,
  SELECT_SERVICE,
  UNSELECT_SERVICE,
} from '../actions/ActionTypes';

export type ServiceSelection = {
  guid: string;
  providerGuid?: string;
  optionId?: string;
  bookingOrder?: number;
};

const initialState: ServiceSelection[] = [];

export default function selectedServices(
  state: ServiceSelection[] = initialState,
  action: ServiceSelectionAction,
): ServiceSelection[] {
  switch (action.type) {
    case CLEAR_SERVICES:
      return initialState;
    case SELECT_SERVICE:
      return state.find((s) => action.payload?.guid == s.guid)
        ? state
        : [...state, action.payload];
    case UNSELECT_SERVICE:
      return state.filter((s) => s.guid !== action.payload.guid);
    default:
      return state;
  }
}
